import { styled } from 'src/ui/theme'

export const MapLink = styled.a`
  white-space: nowrap;
  font-weight: 500;
`
